<div class="courses">
  <div
    class="cards-container"
    [ngClass]="{
      'snake-layout': currentLayoutView === 'SnakeView',
      'grid-layout': currentLayoutView === 'CardView',
      'list-layout': currentLayoutView === 'ListView' || currentLayoutView === 'NumberedListView',
    }"
  >
    @for (card of cards; track card._id; let i = $index) {
      <ptl-card-item
        role="listitem"
        class="card-item"
        [card]="card"
        [cardIndex]="i"
        [viewType]="currentLayoutView"
        (cardClick)="onCardClick($event)"
      ></ptl-card-item>
    }
  </div>
</div>
